import { render, staticRenderFns } from "./RobberyEventTypeQuestion.vue?vue&type=template&id=785c3c18&scoped=true"
import script from "./RobberyEventTypeQuestion.vue?vue&type=script&lang=ts"
export * from "./RobberyEventTypeQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785c3c18",
  null
  
)

export default component.exports